/* o carrossel anda -50%, entao a tira precisa do dobro de cartoes.
   clonar aqui em vez de repetir no HTML evita embutir cada foto
   duas vezes em base64 */
(function(){
  var track = document.querySelector('.cw-revtrack');
  if (!track) return;
  var originals = Array.prototype.slice.call(track.children);
  originals.forEach(function(node){
    var copy = node.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    track.appendChild(copy);
  });
})();

/* clicar numa miniatura troca ela de lugar com a foto principal,
   assim nenhuma das seis imagens some da tira */
(function(){
  var main = document.getElementById('cw-main');
  var thumbs = document.querySelectorAll('.cw-thumb');
  if (!main || !thumbs.length) return;
  function swap(box){
    var img = box.querySelector('img');
    if (!img || img.src === main.src) return;
    var a = main.getAttribute('src'), b = img.getAttribute('src');
    main.classList.add('is-swapping');
    setTimeout(function(){
      main.setAttribute('src', b);
      img.setAttribute('src', a);
      main.classList.remove('is-swapping');
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      box.classList.add('is-active');
    }, 120);
  }
  thumbs.forEach(function(box){
    box.addEventListener('click', function(){ swap(box); });
    box.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); swap(box); }
    });
  });
})();


/* mostra a barra fixa so depois que o botao original sai da tela.
   o clique e repassado para o botao real, entao nao ha logica duplicada. */
(function(){
  var bar  = document.getElementById('cw-sticky');
  var real = document.querySelector('.scp0');
  if (!bar || !real) return;

  bar.querySelector('.cw-sticky-btn').addEventListener('click', function(){
    real.click();
  });

  /* so aparece depois que o botao original ja passou para cima da tela,
     nunca antes de o visitante ver a oferta */
  function sync(){
    bar.classList.toggle('is-on', real.getBoundingClientRect().bottom < 0);
  }
  addEventListener('scroll', sync, {passive:true});
  addEventListener('resize', sync);
  sync();
})();

/* o seletor de quantidade era um <span> inerte; agora move o input do form */
(function(){
  var input = document.getElementById('cw-qty-input');
  var label = document.querySelector('.cw-qty-label');
  if (!input || !label) return;
  var btns = document.querySelectorAll('.cw-qty-btn');
  function set(v){
    v = Math.max(1, Math.min(99, v));
    input.value = v; label.textContent = v;
  }
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      set(parseInt(input.value, 10) + (b.dataset.step === '-' ? -1 : 1));
    });
  });
})();

/* ADD TO CART vai direto para o checkout, com uma unidade do ebook junto.
   nao ha mais passagem pela pagina de carrinho, entao nada corrige o ebook depois:
   por isso o produto entra por add.js (aditivo, respeita a quantidade escolhida)
   e o ebook por update.js, que crava exatamente 1 mesmo se ja houvesse um no
   carrinho de uma visita anterior.
   se algo falhar depois do produto ja ter entrado, manda para /cart em vez de
   repetir o add — /cart se encarrega de consertar e seguir para o checkout.

   desde 15/09/2026 a compra SUBSTITUI o carrinho (assets/carrinho-substitui.js):
   esvazia antes do add, entao o checkout recebe so esta escolha, e nao o
   aparelho da visita anterior somado (x3, x7, os dois bracos do teste de preco
   juntos, medidos nos abandonados). toque duplo com a compra em curso e
   ignorado. sem aquele arquivo, compra como antes. */
(function(){
  var EBOOK = 54677877686547;
  var form  = document.getElementById('cw-buy');
  if (!form || !window.fetch) return;

  form.addEventListener('submit', function(e){
    var id = form.querySelector('input[name="id"]');
    if (!id) return;                       /* deixa o nativo assumir */
    e.preventDefault();

    var cs = window.carrinhoSubstitui;
    if (cs && cs.ocupado()) return;        /* toque duplo: a primeira compra segue */

    var qty   = parseInt((document.getElementById('cw-qty-input') || {}).value, 10) || 1;
    var ctrl  = new AbortController();
    var t     = setTimeout(function(){ ctrl.abort(); }, 6000);
    var added = false;

    function post(url, body){
      return fetch(url, {
        method:  'POST',
        headers: {'Content-Type': 'application/json'},
        body:    JSON.stringify(body),
        signal:  ctrl.signal
      }).then(function(r){ if (!r.ok) throw new Error(r.status); return r; });
    }

    function passo(){
      return post('/cart/add.js', {items: [{id: parseInt(id.value, 10), quantity: qty}]})
        .then(function(){
          added = true;
          var updates = {}; updates[EBOOK] = 1;
          return post('/cart/update.js', {updates: updates});
        });
    }

    /* o que o carrinho tem de conter no fim: o aparelho na quantidade escolhida
       e um ebook — o carrinho-substitui confere e corrige antes do checkout */
    var esperado = [{id: parseInt(id.value, 10), quantity: qty}, {id: EBOOK, quantity: 1}];
    (cs ? cs.substituir(passo, esperado) : passo())
      .then(function(){
        clearTimeout(t);
        location.href = '/checkout';
      })
      .catch(function(){
        clearTimeout(t);
        if (added) location.href = '/cart';  /* produto ja entrou: nao adicionar de novo */
        else       form.submit();            /* nada entrou: submit nativo */
      });
  });
})();
